/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, ReactNode} from 'react'
import classNames from 'classnames'
import {useIntl} from 'react-intl'
import { Spinner } from './Spinner'

interface Props {
  loading: boolean
  rowSelected: string | undefined
  nextPage: string | undefined
  nextPageOnClickHandler: () => void
  searchControlsComponent: ReactNode
  listComponent: ReactNode
}

const SearchList: FC<Props> = ({
  loading,
  rowSelected,
  nextPage,
  nextPageOnClickHandler,
  searchControlsComponent,
  listComponent,
}) => {
  const intl = useIntl()

  return (
    <>
      <div
        className={classNames({
          'd-none': rowSelected,
          'd-lg-block': rowSelected,
          'col-lg-5': rowSelected,
          'col-lg-12': !rowSelected,
        })}
      >
        <div className='card card-stretch-100 card-bordered'>
          <div className='card-header pb-3'>{searchControlsComponent}</div>
          <div className='card-body pt-5'>
            {loading && !nextPage ? (
              <Spinner heightClass='h-300px' withClass='w-350px' />
            ) : (
              <>
                <div className='card-scroll h-600px '>{listComponent}</div>
                {nextPage && (
                  <div
                    className='d-flex flex-column flex-row-fluid btn btn-sm btn-primary mt-2'
                    onClick={nextPageOnClickHandler}
                  >
                    <div className='d-flex flex-row flex-column-fluid'>
                      <div className='d-flex flex-row-fluid flex-center'>
                        <div className='d-flex align-items-center'>
                          {loading ? (
                            <span className='indicator-progress' style={{display: 'block'}}>
                              {intl.formatMessage({id: 'UTIL.PROCESSING'})}
                            </span>
                          ) : (
                            <>
                              <i className='bi bi-download me-3'></i>
                              <span className='indicator-label'>
                                {intl.formatMessage({id: 'UTIL.LOAD_MORE'})}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export {SearchList}
